<template>
  <div class="index">
    <div
      class="view"
      :class="{'no-menu':!showMenu}"
    >
      <router-view></router-view>
    </div>
    <mt-tabbar
      v-model="selected"
      fixed
      v-if="showMenu"
      style="padding-bottom:0.1rem"
    >
      <mt-tab-item
        id="tab1"
        @click.native="goMenu('homepage')"
      >
        <span
          slot="icon"
          class="icon iconfont icon-shouyexianxing"
          v-if="selected != 'tab1'"
        ></span>
        <img
          slot="icon"
          src="../assets/img/shouye_s.png"
          v-if="selected == 'tab1'"
          class="icon_img"
        >
        首页
      </mt-tab-item>
      <!-- <mt-tab-item
        id="tab6"
        @click.native="goMenu('sharerank')"
        v-if="role!='sale'"
      >
        <span
          slot="icon"
          class="icon icon-yejixianxing iconfont"
          v-if="selected != 'tab6'"
        ></span>
        <img
          slot="icon"
          src="../assets/img/yeji_s.png"
          v-if="selected == 'tab6'"
          class="icon_img"
        >
        分享排行
      </mt-tab-item> -->
      <!--<mt-tab-item id="tab2" @click.native="goMenu('sales')" v-if="departmentId == 2 || departmentId == 1">-->
      <mt-tab-item
        id="tab2"
        @click.native="goMenu('performance')"
      >
        <span
          slot="icon"
          class="icon icon-yejixianxing iconfont"
          v-if="selected != 'tab2'"
        ></span>
        <img
          slot="icon"
          src="../assets/img/yeji_s.png"
          v-if="selected == 'tab2'"
          class="icon_img"
          style="width: 27px;"
        >
        业绩
      </mt-tab-item>
      <mt-tab-item
        id="tab6"
        @click.native="goMenu('sharerank')"
        class="fenxi"
        v-if="role =='sale' "
      >
        <span
          slot="icon"
          class="icon icon-fenxi iconfont"
          v-if="selected != 'tab6'"
        ></span>
        <img
          slot="icon"
          src="../assets/img/fenxi_s.png"
          v-if="selected == 'tab6'"
          class="icon_img"
          style="width: 29.44px;height: 24px;"
        >
        分享排行
      </mt-tab-item>
      <mt-tab-item
        id="tab3"
        @click.native="goMenu('businessmon')"
        class="fenxi"
        v-if="role!='sale'"
      >
        <span
          slot="icon"
          class="icon icon-fenxi iconfont"
          v-if="selected != 'tab3'"
          style=""
        ></span>
        <img
          slot="icon"
          src="../assets/img/fenxi_s.png"
          v-if="selected == 'tab3'"
          class="icon_img"
          style="width: 29.44px;height: 24px;"
        >
        &nbsp分析
      </mt-tab-item>
      <!--<mt-tab-item id="tab4" @click.native="goMenu('myproject')" v-if="departmentId == 23 || departmentId == 24 || departmentId == 25 || departmentId == 26 || departmentId == 27 || departmentId == 28">-->
      <mt-tab-item
        id="tab4"
        @click.native="goMenu('myproject')"
        v-if="role=='manager'"
      >
        <span
          slot="icon"
          class="icon icon-xiangmu iconfont"
          v-if="selected != 'tab4'"
        ></span>
        <img
          slot="icon"
          src="../assets/img/xiangmu_s.png"
          v-if="selected == 'tab4'"
          class="icon_img"
        >
        项目
      </mt-tab-item>
      <mt-tab-item
        id="tab5"
        @click.native="goMenu('my')"
      >
        <span
          slot="icon"
          class="icon icon-wode iconfont"
          v-if="selected != 'tab5'"
        ></span>
        <img
          slot="icon"
          src="../assets/img/wode_s.png"
          v-if="selected == 'tab5'"
          style="width: 17px;height: 24px;margin-left:4px;"
          class="icon_img"
        >
        我的
      </mt-tab-item>
    </mt-tabbar>

  </div>
</template>


<script>
import Vue from 'vue'
import { Tabbar, TabItem } from 'mint-ui'
Vue.component(Tabbar.name, Tabbar)
Vue.component(TabItem.name, TabItem)
export default {
  data() {
    return {
      selected: 'tab1',
      departmentId: '',
      role: '',

      uid: '',
    }
  },
  methods: {
    goMenu(name) {
      this.$router.push({ name: name })
      window.localStorage.removeItem('drillData')
    },
   
    //   getBugNoReadNum (){
    // this.$http.getBugNoReadNum({user_id:this.uid}).then(res=>{
    //               this.bugNum=res.data.count==0　? 0:res.data.count
    //           })
    //   }
    //获取bug唯独信息数
    getClass(role) {
      if (role == 'sale') {
        return 'icon-yejixianxing iconfont'
      } else {
        return 'icon icon-fenxi iconfont'
      }
    },
    getImg(role) {
      if (role == "sale") {
        return '../assets/img/yeji_s.png'
      } else {
        return '../assets/img/fenxi_s.png'
      }
    }

  },
  watch: {
    '$route.name': function () {
      switch (this.$route.name) {
        case 'homepage':
          this.selected = 'tab1'//首页
          break
        case 'performance':
          this.selected = 'tab2'//业绩
          break
        case 'businessmon':
          this.selected = 'tab3'
          break
        case 'businessyear':
          this.selected = 'tab3'
          break
        case 'make':
          this.selected = 'tab3'
          break
        case 'project':
          this.selected = 'tab3'
          break
        case 'myproject':
          this.selected = 'tab4'//项目
          break
        case 'my':
          this.selected = 'tab5'//我的
          break
        case 'sharerank':
          this.selected = 'tab6'//分享排行
          break
      }
    }
  },
  computed: {
    showMenu() {
      if (this.$route.name == 'homepage' || this.$route.name == 'performance' || this.$route.name == 'businessmon' || this.$route.name == 'businessyear' || this.$route.name == 'make' || this.$route.name == 'project' || this.$route.name == 'myproject' || this.$route.name == 'my' || this.$route.name == 'sharerank') {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    this.departmentId = window.localStorage.getItem('departmentId')
    this.role = window.localStorage.getItem('role')
    this.uid = window.localStorage.getItem('userId')//获取userId

    switch (this.$route.name) {
      case 'homepage':
        this.selected = 'tab1'
        break
      case 'sales':
        this.selected = 'tab2'
        break
      case 'businessmon':
        this.selected = 'tab3'
        break
      case 'businessyear':
        this.selected = 'tab3'
        break
      case 'make':
        this.selected = 'tab3'
        break
      case 'project':
        this.selected = 'tab3'
        break
      case 'myproject':
        this.selected = 'tab4'
        break
      case 'my':
        this.selected = 'tab5'
        break
    }
    // 获取未读消息
    // this.getNoReadNum()

    // 接收获取最新消息
    // this.$root.Bus.$on('getNewNum', res => {
    //   this.getNoReadNum()
    // })
    // this.getBugNoReadNum()
    // 接收获取最新bug反馈消息
    // this.$root.Bus.$on('getNewBugNum',res=>{
    //   this.getBugNoReadNum()
    // })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html,
body {
  height: 100%;
  width: 100%;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
.icon {
  font-size: 24px;
  color: #5482d1;
}
.index {
  width: 100%;
  height: 100%;
}
.view {
  padding-bottom: 55px;
  overflow: scroll;
  width: 100%;
  height: 100%;
}
.view.no-menu {
  padding-bottom: 0px;
}
.mint-tabbar {
  color: #999;
  background-color: #f9f7f7;
  background-size: 100% 0px;
}
.mint-tabbar > .mint-tab-item.is-selected {
  background-color: #f9f7f7;
  color: #999;
}
.show-number {
  position: absolute;
  top: 10%;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  text-align: center;
  background: #f00;
  color: #fff;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue